@if (productFlag) {
  <div class="product-small-flag">
    @if (isLimitedInventory) {
      <span class="limited-inventory">limited inventory</span>
    }
    @if (isNew) {
      <span class="new">New</span>
    }
    @if (isSale) {
      <span class="sale">Sale</span>
    }
    @if (isShipsSoon) {
      <span class="ships-soon">Ships Soon</span>
    }
  </div>
}
